module.exports = __webpack_public_path__ + "static/media/CTLI_2-444w.23344cca.webp";